import React, { useEffect, useState } from "react";
const CheckboxComponent = ({
  name,
  classNameCheckbox,
  label,
  classNameLabel,
  sublabel,
  classNameSublabel,
  checked,
  onChange
}) => {
  const [isChecked, setIsChecked] = useState(!!checked);
  useEffect(() => {
    // Reset state if there's a change in the parent state`
    setIsChecked(!!checked);
  }, [checked]);
  const changeHandler = () => {
    setIsChecked(!isChecked);
    if (onChange) onChange(!isChecked);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-6 items-center"
  }, /*#__PURE__*/React.createElement("input", {
    "aria-describedby": "comments-description",
    name: name,
    type: "checkbox",
    className: `h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600 ${classNameCheckbox}`,
    checked: isChecked,
    onChange: changeHandler
  })), /*#__PURE__*/React.createElement("div", {
    className: "ml-3 text-sm leading-6"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: name,
    className: `font-medium text-gray-900 ${classNameLabel}`
  }, label), " ", /*#__PURE__*/React.createElement("span", {
    className: `text-gray-500 ${classNameSublabel}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, label, " "), sublabel)));
};
export { CheckboxComponent };